/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { Typography } from "@material-ui/core";
import React, { Suspense } from "react";

const Show = React.lazy(() => import("./Show"));

export const apiKeyRoute = {
  path: "/api-keys",
  key: "api-keys",
  component: () => (
    <Suspense fallback={<Typography variant="body1">Loading...</Typography>}>
      <Show />
    </Suspense>
  ),
};
